<template>
  <div>
    <p style="text-align: center;min-width: 1580px;">
      <span class="systemFont1">{{$t('P0361.orderInquiryTitle')}}</span>
    </p>
    <el-row style="top: 17px; min-width: 1580px;" >
      <!-- 模糊查询 -->
      <div style="display: inline-block;">
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="100px"
          class="systemFont1"
        >
          <!-- 课程名称 -->
          <div style="width:430px;display: inline-block; float:left;">
            <el-form-item :label="$t('P0361.courseName')">
              <el-input
                name="queryForm.courseName"
                type="text"
                v-model="queryForm.courseName"
                clearable
                :placeholder="$t('P0361.courseName')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <!-- 订单支付时间 -->
          <div style="width:400px;display:inline-block; float:left;">
            <el-form-item :label="$t('P0361.paymentTime')">
              <el-date-picker
                name="queryForm.orderPayTime"
                v-model="queryForm.orderPayTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                :placeholder="$t('P0361.date')"
                style="width: 300px"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- 关键字 -->
          <div style="width:400px;display: inline-block; float:left;">
            <el-form-item :label="$t('P0361.keywords')">
              <el-input
                name="queryForm.searchCriteria"
                type="text"
                v-model="queryForm.searchCriteria"
                clearable
                :placeholder="$t('P0361.purchaser') + '/' + $t('P0361.telephone') + '/' + $t('P0361.invoicingCompany')"
              ></el-input>
            </el-form-item>
          </div>
          <div
            style="width:70px;height:100%;display: inline-block; float:left;"
          >
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </div>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-row><br /></el-row>
      </el-col>
    </el-row>
    <!-- 订单信息数据一览 -->
    <el-row style="top: 17px">
      <el-col :span="22" :offset="1">
        <el-table
          :data="ordersData"
          style="min-width: 1580px; margin-bottom: 75px">
          <!-- 订单号 -->
          <el-table-column
            prop="orderId"
            :label="$t('P0361.orderId')"
            align="center"
            width="190px">
          </el-table-column>
          <!-- 订单支付时间 -->
          <el-table-column
            prop="orderPayTime"
            :formatter="dateAndTimeFormat"
            :label="$t('P0361.paymentTime')"
            align="center"
            width="190px">
          </el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('P0361.courseName')"
            align="left"
            width="151px">
          </el-table-column>
          <!-- 课程单价 -->
          <el-table-column
            prop="unitPrice"
            :label="$t('P0361.coursePrice')"
            :formatter="formatPrice"
            align="right"
            width="94px">
          </el-table-column>
          <!-- 报名人数 -->
          <el-table-column
            prop="applicantsNumber"
            :label="$t('P0361.applicants')"
            align="center"
            width="94px">
          </el-table-column>
          <!-- 优惠码 -->
          <el-table-column
            prop="couponCode"
            :label="$t('P0361.couponCode')"
            align="center"
            width="105px">
          </el-table-column>
          <!-- 优惠价格 -->
          <el-table-column
            prop="couponPrice"
            :label="$t('P0361.discountedPrice')"
            :formatter="formatPrice2"
            align="right"
            width="94px">
          </el-table-column>
          <!-- 入账总额 -->
          <el-table-column
            prop="entryPrice"
            :label="$t('P0361.totalCredit')"
            :formatter="formatPrice3"
            align="right"
            width="94px">
          </el-table-column>
          <!-- 支付方式 -->
          <el-table-column
            prop="orderPayTypeSTR"
            :label="$t('P0361.paymentMethod')"
            align="center"
            width="94px">
          </el-table-column>
          <!-- 购买人 -->
          <el-table-column
            prop="buyerName"
            :label="$t('P0361.purchaser')"
            align="center"
            width="94px">
          </el-table-column>
          <!-- 购买人手机 -->
          <el-table-column
            prop="buyerPhone"
            :label="$t('P0361.purchaserPhone')"
            align="center"
            width="117px">
          </el-table-column>
          <!-- 开票公司 -->
          <el-table-column
            prop="invoicingCompany"
            :label="$t('P0361.invoicingCompany')"
            align="left"
            width="161px">
            <template slot-scope="scope">
              <div v-if="scope.row.invoicingFlag == 0">-</div>
              <div v-else>
                {{ scope.row.invoicingCompany }}
              </div>
            </template>
          </el-table-column>
          <!-- 备注 -->
          <el-table-column
            :label="$t('P0361.remark')"
            align="center"
            width="55px">
            <template slot-scope="scope">
              <div v-if="!scope.row.remarks">
                {{$t('P0361.null')}}
              </div>
              <div v-else>
                <el-popover
                placement="bottom"
                width="200"
                trigger="hover">
                <template v-solt="">
                  <pre class="preSpecificContent">{{ scope.row.remarks }}</pre>
                  <div slot="reference">
                    <el-button type="text" slot="reference">{{$t('P0361.details')}}</el-button>
                  </div>
                </template>
              </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
  
<script>
import moment from 'moment';
export default {
  data() {
    return {
      // 一览数据
      ordersData: [],
      // 查询条件
      queryForm: {
      courseName: "",
      orderPayTime: "",
      searchCriteria: ""
      },
    // 当前页
    currentPageCo: 1,
    // 每页件数
    pageSizeCo: 20,
    totalCo: 0,
    }
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.ordersData == undefined || this.ordersData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化订单信息一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('common.loading'),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      if (val) {
      // 分页数据初始化
      this.currentPageCo = 1;
      this.totalCo = 0;
      }
      let url = "/api/greenJacketOrder/searchOrders"
      this.$http
        .post(url, {
        //模糊查询
        courseName: this.queryForm.courseName,
        orderPayTime: this.queryForm.orderPayTime,
        searchCriteria: this.queryForm.searchCriteria,
        // 当前页
        currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
        // 页数
        pageSizeCo: this.pageSizeCo,
        // 总数
        totalCo: this.totalCo
        })
        .then((response) => {
          loading.close()
          if (response.data.code === 200) {
            // 判断有没有数据
          if (response.data.data == null) {
            this.ordersData = [];
          } else {
            // 总数取值
            this.totalCo = response.data.data[0].totalCo;
            // 渲染页面
            this.ordersData = response.data.data;
          }
          } else {
            this.$message.error(response.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
          loading.close()
          this.$message.error(this.$t('common.anErrorOccurred'))
        });
    },
    // 时间标准化
    dateAndTimeFormat(row) {
      if(row.orderPayTime!=null&&row.orderPayTime!=""){
        return moment(row.orderPayTime).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 货币格式
    formatPrice(row) {
      var price = "";
      if (row.unitPrice != "" && row.unitPrice != null) {
        price = row.unitPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        if (price.includes(".")) {
          price = price.split(".")[1].length < 2 ? price + "0" : price;
        } else {
          price += ".00";
        }
        return price;
      }
    },
    formatPrice2(row) {
      var price = "";
      if (row.couponPrice != "" && row.couponPrice != null) {
        price = row.couponPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        if (price.includes(".")) {
          price = price.split(".")[1].length < 2 ? price + "0" : price;
        } else {
          price += ".00";
        }
        return price;
      }
    },
    formatPrice3(row) {
      var price = "";
      if (row.entryPrice != "" && row.entryPrice != null) {
        price = row.entryPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        if (price.includes(".")) {
          price = price.split(".")[1].length < 2 ? price + "0" : price;
        } else {
          price += ".00";
        }
        return price;
      }
    },
  },
  mounted() {
    if (this.$route.query.currentPageCo) {
      this.currentPageCo = Number(this.$route.query.currentPageCo);
    }
    if (this.$route.query.totalCo) {
      this.totalCo = Number(this.$route.query.totalCo);
    }
    if (this.$route.query.pageSizeCo) {
      this.pageSizeCo = Number(this.$route.query.pageSizeCo);
    }
    if (this.$route.query.courseName) {
      this.queryForm.courseName = this.$route.query.courseName;
    }
    if (this.$route.query.orderPayTime) {
      this.queryForm.orderPayTime = this.$route.query.orderPayTime;
    }
    if (this.$route.query.searchCriteria) {
      this.queryForm.searchCriteria = this.$route.query.searchCriteria;
    }
    this.init();
  }
}
  </script>
  
  <style lang="scss" scoped>
  
  >>>.el-table thead{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    color: #333333;
    font-size: 16px;
  }
  
  >>>.el-table__header {
    border-bottom: 3px solid rgb(170, 170, 170)
  }
  
  >>>.el-table__row {
    height: 42px;
  }
  
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 0.5px solid rgb(170, 170, 170);
  }
  
  >>>.el-table--border::after, .el-table--group::after, .el-table::before{
    background: none;
  }

  
.preSpecificContent{
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  color: #666666;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0px;
}
  </style>
  


// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0361.vue